// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__8Jy5E","info":"hero_info__weVzA","divider":"hero_divider__RGbxj"};